export default __webpack_public_path__ + "static/media/talent-header-playing-field-Dev-IT.b0891c0f.svg";